<template>
	<b-modal
		ref="create-knives-modal"
		size="md"
		hide-footer
		@hidden="handleCloseModal"
		no-close-on-backdrop
		no-close-on-esc
	>
		<template #modal-header>
			<div class="d-flex justify-content-between align-items-center w-100">
				<div class="font-weight-bold">Crear Navajas</div>
				<div class="d-flex gap-x-2">
					<div style="display: flex; gap: 0.5rem">
						<b-button
							variant="success"
							@click="createKnife"
							v-b-tooltip.hover="'Guardar'"
							:disabled="!code"
						>
							<FeatherIcon icon="SaveIcon" />
						</b-button>
					</div>
					<div style="display: flex; gap: 0.5rem">
						<b-button variant="danger" @click="handleCloseModal" v-b-tooltip.hover="'Cerrar'">
							<FeatherIcon icon="XIcon" />
						</b-button>
					</div>
				</div>
			</div>
		</template>
		<b-row>
			<b-col>
				<b-form-group label="Código" label-for="code">
					<div class="d-flex align-items-center">
						<v-select
							v-model="code"
							:options="codes"
							placeholder="Seleccionar"
							:clearable="false"
							class="w-100"
						></v-select>
						<b-button variant="flat-primary" @click="showAddCodeModal = true">
							<FeatherIcon icon="PlusIcon" size="20" />
						</b-button>
					</div>
				</b-form-group>
			</b-col>
			<!-- <b-col>
				<b-form-group label="Tamaño(cm)" label-for="size">
					<b-form-input id="size" v-model="size" type="number" placeholder="Opcional" />
				</b-form-group>
			</b-col> -->
		</b-row>
		<b-form-group :label="`Selecciona la cantidad de navajas que deseas agregar`" class="mt-1">
			<div class="d-flex justify-content-center align-items-center mt-1">
				<feather-icon
					@click="quantity > 1 ? quantity-- : quantity"
					icon="MinusCircleIcon"
					size="50"
					class="cursor-pointer"
					:class="{ 'text-danger': quantity == 1, 'text-success': quantity > 1 }"
				/>
				<div class="container-number bg-primary">
					<p class="mb-0 font-small-4 d-flex justify-content-center align-items-center">
						{{ quantity }}
					</p>
				</div>

				<feather-icon @click="quantity++" icon="PlusCircleIcon" size="50" class="cursor-pointer text-success" />
			</div>
		</b-form-group>
		<b-modal
			title="Agregar Código"
			ref="add-code-modal"
			v-model="showAddCodeModal"
			hide-footer
			no-close-on-backdrop
			no-close-on-esc
			size="sm"
		>
			<b-form @submit.prevent="addCode">
				<b-form-group label="Código" label-for="new-code">
					<b-form-input
						id="new-code"
						v-model="newCode"
						placeholder="Ingrese el código"
						@input="(val) => (newCode = newCode.toUpperCase())"
					/>
				</b-form-group>
				<div class="d-flex justify-content-end">
					<b-button type="submit" variant="success">Agregar</b-button>
				</div>
			</b-form>
		</b-modal>
	</b-modal>
</template>

<script>
import TournamentKnivesService from "@/views/brain/tournament/views/knives/services/tournament-knives.service.js"

export default {
	name: "CreateKnivesModal",
	props: {},
	components: {},
	data: () => ({
		code: null,
		quantity: 1,
		size: null,
		codes: [],
		newCode: "",
		showAddCodeModal: false,
	}),
	computed: {},
	methods: {
		handleCloseModal() {
			this.$emit("close")
		},

		async createKnife() {
			try {
				await TournamentKnivesService.saveKnife({
					code: this.code,
					quantity: this.quantity,
					initial_size: this.size,
				})
				this.showSuccessToast("Navajas creadas exitosamente")
				this.$emit("refresh")
				this.handleCloseModal()
			} catch (error) {
				console.error("Error creating knife:", error)
			}
		},
		async getCodes() {
			try {
				const { data } = await TournamentKnivesService.getCodes()
				this.codes = data
			} catch (error) {
				console.error("Error creating knife:", error)
			}
		},

		addCode() {
			this.newCode = this.newCode.trim()
			if (!this.newCode) {
				this.showToast("warning", "top-right", "Navajas", "AlertCircleIcon", "El código es requerido")
				return
			}
			if (this.codes.includes(this.newCode)) {
				this.showToast("warning", "top-right", "Navajas", "AlertCircleIcon", "El código ya existe")
				return
			}
			this.codes.push(this.newCode)
			this.newCode = null
			this.showAddCodeModal = false
		},
	},

	mounted() {
		this.getCodes()
		this.$refs["create-knives-modal"].toggle()
	},
}
</script>
<style lang="scss" scoped>
.container-number {
	height: 50px;
	width: 50px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #fff;
	margin: 0 0.1rem;
	p {
		display: flex;
		align-items: center;
		justify-content: center;
		font-weight: bolder !important;
	}
}
</style>
